module.exports = __webpack_public_path__ + "static/media/button_menu.7960b854.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/button_menu.svg
// module id = 235
// module chunks = 0